import { useUpdateUserPhaseActionStatus } from "@platform/hooks/useUpdateUserPhaseActionStatus";
import { useFetchUserPhaseActions } from "@platform/hooks/useFetchUserPhaseActions";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import VideoUIJoin from "./VideoUIJoin";
import useMeetingRelatedUserPhaseAction from "@platform/features/video/hooks/useMeetingRelatedUserPhaseAction";
import { PhaseActionType } from "@platform/types/dashboard.types";

type Props = {
  meetingDetails: MeetingDetails;
  meetingStartTime?: string;
  isDevicesLoading: boolean;
};

export function VideoUIJoinContainer({
  meetingDetails,
  meetingStartTime,
  isDevicesLoading,
}: Props) {
  const { isLoading: isLoadingUserPhaseActions } = useFetchUserPhaseActions({
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const meetingUserPhaseAction = useMeetingRelatedUserPhaseAction(
    meetingDetails?.id.toString(),
    meetingDetails?.meeting_type === "meeting_standalone"
      ? ("meeting_standalone" as PhaseActionType)
      : ("meeting" as PhaseActionType)
  );

  const completeUserPhaseActionMutation = useUpdateUserPhaseActionStatus({
    userPhaseActionId: parseInt(meetingUserPhaseAction?.id || "0", 10),
    status: "completed",
  });

  const onJoinMeeting = async () => {
    completeUserPhaseActionMutation?.mutateAsync();
  };

  return (
    <VideoUIJoin
      meetingDetails={meetingDetails}
      meetingStartTime={meetingStartTime}
      isDevicesLoading={isDevicesLoading}
      onJoinMeeting={onJoinMeeting}
      isActionLoading={isLoadingUserPhaseActions}
    />
  );
}

export default VideoUIJoinContainer;
